import React from 'react';
import PropTypes from 'prop-types';
import "./style.scss";

const Pagination = ({ currentStep, changeStep }) => {

  return (
    <ul className={"eac__pagination"}>
      <li onClick={() => changeStep(0)} className={!currentStep ? "active" : ""}></li>
      <li className={currentStep ? "active" : ""}></li>
    </ul>
  );

};

Pagination.propTypes = {
  currentStep: PropTypes.number.isRequired,
  changeStep: PropTypes.func.isRequired,
};

export default Pagination;
